
module.exports = {
    messages: {
        de: {
            facets: {
                archiv: "Archive",
                abt: "Abteilung",
                band: "Band",
                person: "Personen",
                project: "Stücke",
                showAll: "alle anzeigen",
                title: "Werktitel"
            }
        },
        en: {
            facets: {
                archiv: "Archive",
                abt: "Section",
                band: "Volume",
                person: "Persons",
                project: "Work projects",
                showAll: "show all",
                title: "Work title"
            }
        },
        fr: {
            facets: {
                archiv: "Archive",
                abt: "Section",
                band: "Tome",
                person: "Personnage",
                project: "Projets d'œuvre",
                showAll: "afficher tout",
                title: "Titre d'œuvre"
            }
        }
    }
}
